import { withFeatureBranch } from '@wix/da-shared-react/pkg/redux/flags';
import { default as PostsSection } from './proxy';
import { default as PostsSectionV2 } from '../PostsSection__profile_posts_feed';

export default withFeatureBranch({
  profile_post_feed: PostsSectionV2,
})(PostsSection as any);
